<template>
    <div class="modal fade" id="createFeedback" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Новый отзыв</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label>
                        Выберите тип отзыва
                        <select class="feedback-type" v-model="type">
                            <option v-for="item in this.types" v-bind:value="{ id: item.key, name: item.val }">{{item.val}}</option>
                        </select>
                    </label>
                    <editor :api-key="this.$TINY_MCE_KEY" v-model="comment"></editor>
                    <span class="cancel" v-on:click="cancel">сбросить</span>
                </div>
                <div class="modal-footer">
                    <button @click="save" type="button" class="btn btn-primary">Создать</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import FeedbacksService from "../services/FeedbacksService";
    import Editor from '@tinymce/tinymce-vue';


    const COMPONENT_NAME = 'feedback-modal';

    export default {
        name: COMPONENT_NAME,
        components: {
            "editor": Editor
        },
        data() {
            return  {
                types: [],
                feedback: [],
                comment: '',
                type: [],
            }
        },
        mounted() {
          this.getTypes()
        },
        methods: {
            async getTypes() {
                let response = await FeedbacksService.getTypes();
                if (response.success) {
                    this.types = response.types;
                }
            },
            async save() {

                if (!this.type || !this.comment) {
                    this.$notify({message: 'Должны быть заполнены все поля'});
                    return;
                }

                if (this.type && this.comment) {
                    this.feedback.type = this.type;
                    this.feedback.comment = this.comment;

                    let response = await FeedbacksService.createFeedback(this.type.id, this.comment);
                    if (response.success) {
                        this.$notify({message: 'Отзыв добавлен.', type: 'success'});
                        this.cancel();
                        return this.$parent.renderView();
                    }
                    this.$notify({message: 'Такой отзыв уже есть!', type: 'fail'});
                }
            },
            cancel() {
                this.type = [];
                this.comment = '';
            },
        }
    }
</script>

<style lang="scss" scoped>

    /*.modal-backdrop {*/
    /*    position: fixed;*/
    /*    top: 0;*/
    /*    bottom: 0;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    background-color: rgba(0, 0, 0, 0.3);*/
    /*    display: flex;*/
    /*    justify-content: center;*/
    /*    align-items: center;*/
    /*}*/

    /*.modal {*/
    /*    background: #FFFFFF;*/
    /*    top: unset;*/
    /*    left: unset;*/
    /*    box-shadow: 2px 2px 20px 1px;*/
    /*    overflow-x: auto;*/
    /*    display: flex;*/
    /*    flex-direction: column;*/
    /*    width: auto;*/
    /*    height: auto;*/
    /*    max-width: 80%;*/
    /*    max-height: 90%;*/
    /*    border-radius: 4px;*/
    /*}*/

    /*.modal-footer {*/
    /*    padding: 15px;*/
    /*    display: flex;*/
    /*    border-top: 1px solid #eeeeee;*/
    /*    justify-content: center;*/
    /*}*/

    /*.modal-body {*/
    /*    position: relative;*/
    /*    padding: 0 10px;*/
    /*    overflow-x: auto;*/
    /*    text-align: center;*/
    /*}*/

    .feedback-type, .feedback-text {
        width: 100%;
        margin-top: 15px;
        border-radius: 4px;
    }

    .feedback-type {
        height: auto;
    }

    .feedback-text {
        height: 100%;
    }

    .cancel {
        font-size: 15px;
        &:hover {
            color: #c7004a;
            cursor: pointer;
            text-decoration: underline;
         }
    }

</style>